import React, { useContext, useEffect, useState } from "react";
import { LayoutType, SKListArtifact } from "../../../models/SKArtifact";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from "../../../utils/stringFunctions";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";

interface PopoverProps {
  isOpen: boolean;
  onClose: () => void;
}

const types = [
  {
    imgSrc: "/svg/layoutTable.svg",
    type: LayoutType.table,
    name: "Table",
    redirectURL: "../createTextContent",
  },
  {
    imgSrc: "/svg/layoutGrid.svg",
    type: LayoutType.grid,
    name: "2 Column Grid",
    redirectURL: "",
  },
  {
    imgSrc: "/svg/layoutColumn.svg",
    type: LayoutType.coulmn,
    name: "1 Column Showcase",
    redirectURL: "",
  },
  {
    imgSrc: "/svg/layoutText.svg",
    type: LayoutType.text,
    name: "Text",
    redirectURL: "",
  },
];

const SelectListLayout = ({ isOpen, onClose }: PopoverProps) => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState<LayoutType | null>(null);
  const { contentData, artifactId, updateContentData, loading, saveData } = useContext(CreateArtifactContext);
  const handleTypeSelect = (type: LayoutType) => {
    setSelectedType(type);
  };

  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscKey);
    }

    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [isOpen, onClose]);

  const handleSelect = async () => {
    if (selectedType) {
      updateContentData({
        ...contentData,
        layout: selectedType,
      } as SKListArtifact);
      onClose();
    } else {
      alert("Select type and ");
    }
  };

  return (
    <div className={`fixed z-50 inset-0 flex items-center justify-center ${isOpen ? "visible" : "hidden"}`}>
      <div className="absolute inset-0 bg-black opacity-25"></div>
      <div className="z-10 bg-white rounded-xl shadow-lg max-w-[375px] max-h-[777px] w-full overflow-hidden flex flex-col">
        <div id="catagory" className="flex-grow-[9] flex-shrink-0 p-[30px] overflow-y-auto">
          <p className="content_title">Choose a List Layout</p>
          <p className="notes-class-content">List items are displayed based on the layout.</p>
          <div className="bg-white max-h-[380px] max-w-[375px] mb-[5px] overflow-y-auto">
            <div id="ImageArea" className="flex flex-wrap justify-start gap-[15px] align-middle">
              {types.map((data, index) => (
                <div
                  onClick={() => {
                    handleTypeSelect(data.type);
                  }}
                  key={index}
                  className={`flex flex-col text-center w-[150px] h-[150px] items-center mt-[5px] mb-[5px] rounded-xl border-[1px] ${
                    selectedType === data.type ? "border-black border-[2px]" : "border-[#78788033] border-[2px]"
                  }`}
                >
                  <img src={data.imgSrc} alt={data.type} className="h-[150px] w-[150px] rounded-xl border-[1px]" />
                  <span className="pt-[5px] pb-[15px] font-semibold w-full text-left">{capitalizeFirstLetter(data.name)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="thickseparator h-[2px] bg-gray-300"></div>
        <div id="action_btn" className="flex items-center justify-between m-[30px]">
          <button
            className="w-[113px] h-[46px] text-sm font-normal text-black rounded-lg shadow hover:bg-gray-100 focus:outline-none"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className={`w-[113px] h-[46px] text-sm font-normal text-white rounded-lg shadow hover:bg-gray-700 focus:outline-none ${
              selectedType ? "bg-black" : "bg-gray-300"
            }`}
            onClick={handleSelect}
            disabled={!selectedType}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectListLayout;
